'use client';
import { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT, MOBILE_COLUMN_WIDTH } from '@/libs/config/responsive';

/**
 * 피드 이미지·스켈레톤에 쓰는 가로 크기.
 * 모바일(768px 이하)은 화면 폭을 그대로 쓰고, PC는 기존 가운데 열 폭을 쓴다.
 */
const getWidth = () => (window.innerWidth <= MOBILE_BREAKPOINT ? window.innerWidth : MOBILE_COLUMN_WIDTH);

const useSize = () => {
  const [size, setSize] = useState<{width: number, height: number}>({
    width: MOBILE_COLUMN_WIDTH,
    height: MOBILE_COLUMN_WIDTH,
  });

  useEffect(() => {
    const resize = () => {
      setSize({
        width: getWidth(),
        height: window.innerHeight,
      })
    };

    resize();
    window.addEventListener('resize', resize);

    return () => window.removeEventListener('resize', resize);
  }, []);

  return size;
}

export default useSize;
